// Module
var code = "<tr> <td><img src=\"<%- flagPath %>\" style=vertical-align:middle;width:16px;height:auto title=\"<%- geo %>\"/> <%- geo %></td> <td class=text-right><%- parseInt(total).toLocaleString('en-US') %></td> </tr> ";
// Exports
module.exports = code;